import { render, staticRenderFns } from "./RejectProductLinkModal.vue?vue&type=template&id=5a494944&scoped=true&"
import script from "./RejectProductLinkModal.vue?vue&type=script&lang=js&"
export * from "./RejectProductLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectProductLinkModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RejectProductLinkModal.vue?vue&type=style&index=1&id=5a494944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a494944",
  null
  
)

export default component.exports